import axios from 'axios'

const LoginApi = (values, loginInfo, setCookie, setValues, setStatus, formRef ) => {
  return axios
    .post(
      `${process.env.GATSBY_API_ENDPOINT}/login/AuthenticateUser`,
      loginInfo
    )
    .then(response => {
      const result = response.data.Result

      if (result.UserID > 0) {
        setCookie("ccuserToken", result.AuthToken, 1)

        setValues({
          ...values,
          userfield_firstTimeLogin: result.IsFirstTimeLogin,
          userfield_RememberMe: values.isRememberMe,
          idp: "",
        })

        formRef.current.submit()
      } else {
        setStatus({ isInvalid: true })
      }
    })
    .catch(error => {
      setStatus({ isInvalid: true })
    })
}

export default LoginApi